<script>

import { Form as VeeForm, Field, ErrorMessage } from 'vee-validate'
import * as yup from 'yup'
import { createToast } from 'mosha-vue-toastify'
import 'mosha-vue-toastify/dist/style.css'
import { markRaw } from 'vue'

export default {
  name: "LoginPage",
  components: {
    VeeForm,
    Field,
    ErrorMessage,
  },
  setup () {
    const toast = () => {
        createToast('Connexion réussie', {
            timeout: 3000,
            hideProgressBar: true,
            type: 'success',
            swipeClose: true,
            position: 'top-center',
        })
    }

    const schema = markRaw(yup.object().shape({
      username: yup.string()
        .required("L'email est obligatoire")
        .email("Le format de l'email n'est pas correct")
        .nullable(),
      password: yup.string()
        .required("Le mot de passe est obligatoire")
        .nullable(),
      keep_session_open: yup.bool(),
    }));

    return {
      toast,
      schema,
      mobile_url: import.meta.env.VITE_MOBILE_URL,
    }
  },
  data() {
    return {
      message: "",
      form: {
        username: null,
        password: null,
        keep_session_open: false,
      },
    };
  },
  computed: {
    loggedIn() {
      return this.$store.state.auth.status.loggedIn;
    },
  },
  created() {
    console.log('VITE_MOBILE_URL')
    console.log(import.meta.env.VITE_MOBILE_URL)
    console.log(this.mobile_url)
    if (this.loggedIn) {
      if(this.$route.params.hasOwnProperty('account')) {
        this.$router.push({ name: 'agenda', params: {account: this.$route.params.account} });
      } else {
        this.$router.push({ name: 'dashboard' });
      }
    }
  },
  methods: {
    handleLogin(credentials) {
      this.$store.dispatch('auth/login', credentials).then(
        (response) => {
            this.$store.commit('token/save', {
                'xsrf': response.xsrf_token,
                'refreshToken': response.refresh_token,
                'validitySessionMinutes': response.validity_session_minutes,
            })

            this.$store.commit('profil/save', {
                'user': response.user,
                'authentication': response.authentication,
            })

            this.$eventBus.emit('refresh-validity-session', response.validity_session_minutes)

            this.toast();
            if(localStorage.getItem('account_name')) {
              this.$router.push({ name: 'agenda', params: {account: this.$route.params.account} });
            }
            else {
              this.$router.push({ name: 'dashboard' });
            }
        },
        (error) => {
          if(error.response?.data)
          {
            switch(error.response.data.error) {
              case 'no_credentials':
                this.message = "Email et/ou mot de passe erroné";
                break;
              default:
              this.message =
                (error.response &&
                  error.response.data &&
                  error.response.data.message) ||
                error.message ||
                error.toString();
            }
          }
        }
      );
    },
  },
};

</script>

<template>
  <div class="h-screen flex items-center justify-center my-2">
    <div class="m-auto card card-container p-10 border-solid border border-orange-300 w-full rounded max-w-md">
      <div class="flex justify-center text-xl mb-8">
          <strong class="font-bold">Version mobile</strong>
      </div>

      <div class="mb-8">
          Cette application n'est pas optimale pour les petites écrans.
      </div>

      <div class="mb-8">
          Pour avoir une version adaptée, suivez ce <a class="underline pointer" :href="mobile_url">lien</a>.
      </div>
    </div>
  </div>
</template>
